import { Injectable } from '@angular/core';
import { platformList, sportList } from '../shared.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  loginUserDetails: any = JSON.parse(localStorage.getItem('userDetails'));
  platformandsport = {
    platform_id: 1,
    sport_id: 1
  };

  constructor(
    private api: ApiService,
  ) {
    if (this.loginUserDetails) {
      if (this.loginUserDetails.isLogin) {
        this.platformandsport.platform_id = this.loginUserDetails.userDetails.default_platform_id;
        this.platformandsport.sport_id = this.loginUserDetails.userDetails.default_sport_id;
      } else {
        this.platformandsport.platform_id = this.loginUserDetails.default_platform_id;
        this.platformandsport.sport_id = this.loginUserDetails.default_sport_id;
      }
    }
  }

  getProfileDetails(userid) {
    const data = {
      user_id: userid
    };
    this.api.getProfileDetails(data).subscribe(Data => {
      if (Data && Data.code == 100) {
        const userDet = JSON.parse(localStorage.getItem('userDetails'));
        if (userDet && userDet.userDetails) {

          let platform, sport;
          if (Data.data.userDetails.default_platform_id == platformList.DraftKings) {
            platform = platformList[platformList.DraftKings];
          } else if (Data.data.userDetails.default_platform_id == platformList.FanDuel) {
            platform = platformList[platformList.FanDuel];
          }

          if (Data.data.userDetails.default_sport_id == sportList.NFL) {
            sport = sportList[sportList.NFL];
          } else if (Data.data.userDetails.default_sport_id == sportList.NBA) {
            sport = sportList[sportList.NBA];
          } else if (Data.data.userDetails.default_sport_id == sportList.MLB) {
            sport = sportList[sportList.MLB];
          }

          userDet.platformName = platform;
          userDet.sportName = sport;

          userDet.userDetails = Data.data.userDetails;
          localStorage.setItem('userDetails', JSON.stringify(userDet));
        }
      }
    });
  }

}
